import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
// const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: be,
    dialog: {
      component: 'ClientSelect',
      title: '开票方编号'
    }
  }
}

export default {
  'billto_bp': {
    title: '开票方编号',
    width: 200
  },
  'billto_name': {
    title: '开票方名称',
    width: 250
  },
  'posting_date': {
    title: '发生日期'
  },
  'goods_amount': {
    title: '货款金额(元)',
    xlsxFmt: {
      t: 'n'
    }
  },
  'forward_amount': {
    title: '随货保证金',
    xlsxFmt: {
      t: 'n'
    }
  },
  'dealing_amount': {
    title: '经销商保证金',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/dealer-manage/config/dealerInvoiceQuery.js